import { BowlineIcon } from "@bkry/bowline-components/Icon";
import { getProjectDesignAttributes } from "@bkry/bowline-redux/projectDesigns";
import { getProjectRelationships } from "@bkry/bowline-redux/projects";
import { getEnv } from "@bkry/bowline-utils";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

const BowlineBrandLabel = ({ isConnect }, context) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");

  const projectRelationships = useSelector((state) =>
    getProjectRelationships(state, REACT_APP_PROJECT_ID)
  );

  const projectDesignData = useSelector((state) =>
    getProjectDesignAttributes(
      state,
      projectRelationships?.project_design?.data?.id
    )
  );

  if (!projectDesignData?.bowline_branding && !isConnect) {
    return null;
  }

  return (
    <>
      {context.t("Powered by")}{" "}
      {!isConnect && <BowlineIcon width="16" height="16" />}{" "}
      <strong>Bowline {isConnect && <>Connect</>}</strong>
    </>
  );
};

BowlineBrandLabel.contextTypes = {
  t: PropTypes.func,
};

BowlineBrandLabel.propTypes = {
  isConnect: PropTypes.bool,
};

BowlineBrandLabel.defaultProps = {
  isConnect: false,
};

export default BowlineBrandLabel;

// TODO:
// Add license_rules for bowline branding (i think)
